module.exports = __webpack_public_path__ + "static/pic12-aa797a1cd73c65ccf0477b09727f664c.jpeg";